import React, { useState } from "react";
import { Button } from "react-bootstrap";
import { LoadingSpinnerLabel } from "lib/Spinner";
import { FaIcon } from "lib/FaIcon";
import { removePubFromReadingList } from "../api/readingListApi";

export const RemoveButton = (publication) => {
  const [isLoading, setLoading] = useState(false);

  return (
    <Button
      onClick={() => removePubFromReadingList(publication, setLoading)}
      className="mr-2 my-auto bg-white border-0 btn-sm"
    >
      {isLoading && <LoadingSpinnerLabel />}
      {!isLoading && <FaIcon icon="fas fa-times fa-lg text-dark py-1" />}
    </Button>
  );
};
